import { cn } from '@/lib/utils';
import * as React from 'react';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'flex min-h-[1.5lh] w-full rounded-md border border-input bg-background px-3 py-2 text-[length:var(--fs-subtitle)] leading-[var(--lh-subtitle)] pointer-coarse:text-base placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:border-ring/30 focus-visible:ring-1 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
